import { render } from "./detail-users.vue?vue&type=template&id=5090dee3"
import script from "./detail-users.vue?vue&type=script&lang=js"
export * from "./detail-users.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__